import { Link } from "wouter";
import { LegalLangToggle } from "@/components/LegalPage";
import { useLegalLang } from "@/lib/legalLocale";
import {
  OPERATOR_NAME,
  PRODUCT_NAME,
  PRODUCT_NAME_ZH,
  PUBLIC_PRIVACY_URL,
  PUBLIC_TERMS_URL,
  SUPPORT_EMAIL,
} from "@/lib/publicLinks";

const buttonClass =
  "flex items-center justify-center w-full h-12 rounded-xl border-2 border-black dark:border-white/20 bg-white dark:bg-zinc-900 font-bold text-sm shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] dark:shadow-none hover:translate-x-px hover:translate-y-px hover:shadow-none transition-all";

/**
 * Public legal-site home — no login / signup.
 * TestFlight and the iOS app remain the only product entry points.
 */
export default function LegalHome() {
  const lang = useLegalLang();
  const en = lang === "en";
  return (
    <div className="min-h-screen bg-background flex flex-col pt-safe pb-safe">
      <div className="flex justify-end px-4 pt-3">
        <LegalLangToggle />
      </div>
      <main className="flex-1 max-w-md mx-auto w-full px-6 py-8 flex flex-col justify-center space-y-8">
        <header className="space-y-3 text-center">
          <p className="text-xs font-bold tracking-wide text-muted-foreground uppercase">
            {PRODUCT_NAME}
          </p>
          <h1 className="text-3xl font-black text-foreground">{en ? PRODUCT_NAME : PRODUCT_NAME_ZH}</h1>
          <p className="text-sm font-medium text-muted-foreground leading-relaxed">
            {en ? (
              <>
                This site is for App Store and TestFlight review, and for the public privacy policy and terms.
                <br />
                Use the iOS app from TestFlight or the App Store. This website does not offer sign-in or sign-up.
              </>
            ) : (
              <>
                這是給 App Store／TestFlight 審核與公開說明用的網站。
                <br />
                請透過 iOS 的 TestFlight 或 App Store 使用本服務；此網站不提供登入或註冊。
              </>
            )}
          </p>
        </header>

        <nav className="space-y-3">
          <Link href="/privacy" className={buttonClass}>
            {en ? "Privacy Policy" : "隱私權政策"}
          </Link>
          <Link href="/terms" className={buttonClass}>
            {en ? "Terms of Service" : "服務條款"}
          </Link>
          <a
            href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(en ? `${PRODUCT_NAME} feedback` : `${PRODUCT_NAME} 意見回饋`)}`}
            className="flex items-center justify-center w-full h-12 rounded-xl border-2 border-dashed border-black/30 dark:border-white/20 font-bold text-sm text-muted-foreground hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
          >
            {en ? "Contact us (email)" : "聯絡我們（Email）"}
          </a>
        </nav>

        <footer className="text-center text-xs text-muted-foreground space-y-1 pt-4">
          <p>{en ? "Operator" : "營運者"}：{OPERATOR_NAME}</p>
          <p className="break-all">
            {en ? "Privacy" : "隱私權"}：{" "}
            <a className="underline underline-offset-2" href={PUBLIC_PRIVACY_URL}>
              {PUBLIC_PRIVACY_URL}
            </a>
          </p>
          <p className="break-all">
            {en ? "Terms" : "服務條款"}：{" "}
            <a className="underline underline-offset-2" href={PUBLIC_TERMS_URL}>
              {PUBLIC_TERMS_URL}
            </a>
          </p>
        </footer>
      </main>
    </div>
  );
}
